module.exports = __webpack_public_path__ + "static/media/productivity.ffcb1424.svg";